
export const APIs_URL = {
    STAGING: "https://demo.ced-ntsal.com/engagement-diagnostic/api",
    PRODUCTION: "/engagement-diagnostic/api",
};